<template>
	<div class="approveListing">
		<Loading v-if="loading" />
		<b-row>
			<b-col class="mt-2 mb-2" cols="12" md="6">
				<b-tabs class="tabs-total-noti">
					<b-tab
						:active="paramsGetWaitingForApprove.fillter === 'Day'"
						class="tab-day"
						@click="onChangeFillter('Day')"
					>
						<template v-slot:title>
							<span>{{ $t('approveListing.today') }}</span>
						</template>
						<div class="total">
							<div class="total-numer">{{ itemCount }}</div>
							<div class="text">{{ $t('approveListing.listing') }}</div>
						</div>
					</b-tab>
					<b-tab
						class="tab-mounth"
						:active="paramsGetWaitingForApprove.fillter === 'Month'"
						@click="onChangeFillter('Month')"
					>
						<template v-slot:title>
							<span>{{ $t('approveListing.month') }}</span>
						</template>
						<div class="total">
							<div class="total-numer">{{ itemCount }}</div>
							<div class="text">{{ $t('approveListing.listing') }}</div>
						</div>
					</b-tab>
					<b-tab
						class="tab-year"
						:active="paramsGetWaitingForApprove.fillter === 'Year'"
						@click="onChangeFillter('Year')"
					>
						<template v-slot:title>
							<span>{{ $t('approveListing.year') }}</span>
						</template>
						<div class="total">
							<div class="total-numer">{{ itemCount }}</div>
							<div class="text">{{ $t('approveListing.listing') }}</div>
						</div>
					</b-tab>
					<b-tab
						class="tab-all"
						:active="paramsGetWaitingForApprove.fillter === 'All'"
						@click="onChangeFillter('All')"
					>
						<template v-slot:title>
							<span>{{ $t('all') }}</span>
						</template>
						<div class="total">
							<div class="total-numer">{{ itemCount }}</div>
							<div class="text">{{ $t('approveListing.listing') }}</div>
						</div>
					</b-tab>
				</b-tabs>
			</b-col>
			<b-col cols="12" md="6">
				<div class="noti-pending">
					<div class="wrapper">
						<div class="title">
							{{ $t('approveListing.haveListingsWaiting') }}
						</div>
						<div class="noti-number">{{ totalWaitingForApprove }}</div>
						<div class="text">{{ $t('approveListing.listing') }}</div>
					</div>
				</div>
			</b-col>
			<b-col cols="12">
				<div class="tab-tooltip row">
					<b-col cols="12" lg="6" class="d-block d-md-none">
						<span class="title">{{$t('approveListing.All 5 announcements')}}</span>
					</b-col>
					<b-col cols="12" lg="6">
						<div class="wrap-input-search">
							<b-form-input
								class="input-search"
								@input="onChangeSearch"
								:placeholder="$t('approveListing.Search for announcements')"
							></b-form-input>
						</div>
					</b-col>
					<b-col cols="12" lg="6">
						<div class="group-btn">
							<b-button
								@click="changeTypeViewAlllistings('grid')"
								id="changeViewTypeGrid"
								class="btn-grid"
								v-bind:class="{ active: typeViewAlllistings == 'grid' }"
							>
								<ListGridIcon />
							</b-button>
							<b-button
								@click="changeTypeViewAlllistings('list')"
								id="changeViewTypeList"
								class="btn-list"
								v-bind:class="{ active: typeViewAlllistings == 'list' }"
							>
								<FormatListBulletedIcon />
							</b-button>
							<b-dropdown class="input-choose" no-flip>
								<template v-slot:button-content>
									<span>
										{{
											optionOrderBy.find(
												item =>
													item.value === paramsGetWaitingForApprove.sort_by
											)
												? optionOrderBy.find(
														item =>
															item.value === paramsGetWaitingForApprove.sort_by
												  ).label
												: optionOrderBy[0].label
										}}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									v-for="item in optionOrderBy"
									:key="item.value"
									@click="onChangeOrderBy(item.value)"
									>{{ $t(item.label) }}</b-dropdown-item
								>
							</b-dropdown>
						</div>
					</b-col>
				</div>
			</b-col>
			<b-col cols="12">
				<div
					class="wrap-list list-listings"
					v-if="typeViewAlllistings == 'list'"
				>
					<b-table
						responsive
						hover
						:fields="fields"
						:items="listingWaitingData"
						thead-class="hidden_header"
						:tbody-tr-class="tbodyTrClass"
					>
						<template v-slot:cell(avatar)="data">
							<b-avatar
								:size="isMobile ? 30 : 66"
								class="bg-transparent"
								:src="
									data.item.user && data.item.user.profile_image
										? data.item.user.profile_image
										: '/images/avatar.png'
								"
							></b-avatar>
						</template>
						<template v-slot:cell(listing)="data" style="background: red">
							<div>
								<b-card-text class="categories-name">{{
									data.item.title
								}}</b-card-text>
								<div class="category">
									{{
										data.item.listing_category.listing_category_parent &&
											$t(data.item.listing_category.listing_category_parent.name)
									}}
									> {{ $t(data.item.listing_category.name) }}
								</div>
								<div class="posted-date-div">
									<EditIcon />
									<div class="posted-date">
										{{ formatDate(data.item.updated_at) }} -
										{{ formatHour(data.item.updated_at) }}
									</div>
								</div>

								<div class="tab-price" v-if="!data.item.salaryType">
									<span v-if="data.item.minSalary">
										{{ data.item.minSalary.toLocaleString('th-TH') }}
										{{ $t('baht') }} -
									</span>
									Price
									{{ data.item.price ? data.item.price.toLocaleString('th-TH') : $t('caption.uponRequest') }}
									{{ data.item.price? $t('baht') : '' }}
								</div>
								<div class="tab-price" v-if="data.item.salaryType">
									{{ $t(data.item.salaryType) }}
								</div>
							</div>
						</template>
						<template v-slot:cell(status)="data">
							<div class="column2">
								<div class="paid-promote-option">
									<div
										v-if="checkExistPackage('Feature', data.item.user_payments)"
										class="bookmark"
									>
										<div class="start-while">
											<StarIcon />
										</div>
									</div>
									<div
										v-if="
											checkExistPackage('QuickSale', data.item.user_payments)
										"
										class="hot"
									>
										<div>{{ $t('approveListing.quickSale') }}</div>
									</div>
									<b-button
										v-if="
											checkExistPackage('Negotiable', data.item.user_payments)
										"
										class="btn-negotiable"
										>{{ $t('packages.negotiable.title') }}</b-button
									>
									<div
										v-if="checkExistPackage('Bumpup', data.item.user_payments)"
										class="bump-up"
									>
										<ChevronDoubleUpIcon />
									</div>
									<div
										v-if="checkExistPackage('Website', data.item.user_payments)"
										class="bump-up"
									>
										<MonitorIcon />
									</div>
								</div>
								<div class="user">
									<router-link
										id="sellerDetail"
										class="sellar-div"
										:to="
											$i18nRoute({ name: 'seller-detail' }, data.item.user.id)
										"
									>
										<AccountOutlineIcon />
										<span>{{
											data.item.user && data.item.user.display_name
										}}</span>
									</router-link>
								</div>
							</div>
						</template>
						<template v-slot:cell(view)="data">
							<div class="column3">
								<div class="total-amount">
									{{$t('approveListing.collective promotion')}}: {{ getTotalAmount(data.item.user_payments) }}
									{{ $t('baht') }}
								</div>
								<div class="location">
									<MapMarkerIcon />
									<span>{{ data.item.ip_location }}</span>
								</div>
							</div>
						</template>
						<template v-slot:cell(index)="data">
							<div class="action-div">
								<IconCogOutline :id="'action' + data.index + 1" />
							</div>
							<b-popover
								:target="'action' + data.index + 1"
								placement="right"
								trigger="hover"
							>
								<div class="icon-button">
									<div
										class="button-div one"
										id="gotoListingDetails"
										@click="gotoListingDetails(data.item.id)"
									>
										<EyeIcon />
										<span class="text">{{ $t('approveListing.see') }}</span>
									</div>
									<!-- <div
										v-if="Boolean(data.item.is_show_renew)"
										class="button-div one"
										@click="onRenew(data.item.id)"
										id="onRenew"
									>
										<CheckIcon />
										<span class="text">{{ $t('approveListing.renew') }}</span>
									</div> -->
									<div
										class="button-div one"
										@click="approveListing(data.item.id)"
										id="approveListing"
										
									>
										<CheckIcon />
										<span class="text">{{$t('listingDetail.approve')}}</span>
										<!-- approve -->
									</div>
									<div
										v-if="data.item.status != 2"
										class="button-div two"
										@click="showModal(data.item.id)"
										id="onReject"
									>
										<EyeOffOutlineIcon />
										<span class="text">{{ $t('approveListing.suspend') }}</span>
									</div>
									<div
										class="button-div three"
										id="onDelete"
										@click="deletedItem(data.item.title, data.item.id)"
									>
										<TrashIcon />
										<span class="text">{{ $t('approveListing.delete') }}</span>
									</div>
								</div>
							</b-popover>
						</template>
					</b-table>
					<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
						<span slot="no-results"
							><b-alert show variant="light" v-if="!listingWaitingData.length"
								>{{$t('approveListing.no information')}}</b-alert
							></span
						>
						<span slot="no-more"></span>
					</infinite-loading>
				</div>
				<b-container
					fluid
					class="wrap-list grid-listings"
					v-if="typeViewAlllistings == 'grid'"
				>
					<b-row class="grid" v-for="item in listingWaitingData" :key="item.id" :class="tbodyTrClass(item)">
						<b-col
							cols="12"
							md="4"
							class="left-side"
							@click="gotoListingDetails(item.id)"
							style="cursor:pointer;"
						>
							<div style="position: relative;">
								<b-img fluid :src="item.url_feature_image.replace('832x468', '250x141')" class="main-image"  v-if="item.url_feature_image" :alt="$t('buySell')"/>
								<div class="status-listing" v-if="!item.salaryType">
									<span 
										>{{ item.price ? item.price.toLocaleString('th-TH') : $t('caption.uponRequest') }}
										{{ item.price?$t('baht'):'' }}</span
									>
								</div>
							</div>
							<div class="thumbnail">
								<span v-for="(image, key) in item.listing_images" :key="key">
									<img :src="image.url_image.replace('832x468', '250x141')"  v-if="image.url_image"/>
								</span>
							</div>
						</b-col>
						<b-col class="right-side">
							<!-- <div class="status">
                            <div>Bad Words Found</div>
                          </div>-->
							<b-card-text class="categories-name pl-2 pl-md-0">{{
								item.title
							}}</b-card-text>
							<span class="category pl-2 pl-md-0"
								>{{
									item.listing_category.listing_category_parent &&
										$t(item.listing_category.listing_category_parent.name)
								}}
								> {{ $t(item.listing_category.name) }}</span
							>
							<div class="date-and-location pl-2 pl-md-0">
								<div class="createdAt">
									<EditIcon />
									<div class="posted-date">
										{{ formatDate(item.updated_at) }} -
										{{ formatHour(item.updated_at) }}
									</div>
								</div>
								<div class="location ml-3 ml-md-0">
									<MapMarkerIcon />
									<span>{{ item.ip_location }}</span>
								</div>
							</div>
							<div class="paid-promote-option">
								<div class="package">
									<div
										v-if="checkExistPackage('Feature', item.user_payments)"
										class="bookmark mr-1"
									>
										<div class="start-while">
											<StarIcon />
										</div>
									</div>
									<div
										v-if="checkExistPackage('QuickSale', item.user_payments)"
										class="hot mr-1"
									>
										<div>{{ $t('approveListing.quickSale') }}</div>
									</div>
									<b-button
										v-if="checkExistPackage('Negotiable', item.user_payments)"
										class="btn-negotiable mr-1"
										>{{ $t('packages.negotiable.title') }}</b-button
									>
									<div
										v-if="checkExistPackage('Bumpup', item.user_payments)"
										class="bump-up mr-1"
									>
										<ChevronDoubleUpIcon />
									</div>
									<div
										v-if="checkExistPackage('Website', item.user_payments)"
										class="bump-up mr-1"
									>
										<MonitorIcon />
									</div>
								</div>
								<div class="total-amount">
									{{$t('approveListing.collective promotion')}}: {{ getTotalAmount(item.user_payments) }}
									{{ $t('baht') }}
								</div>
							</div>
							<!--job category-->
							<div v-if="!item.salaryType">
								<span v-if="item.minSalary">
									{{ item.minSalary.toLocaleString('th-TH') }}
									{{ $t('baht') }} -
								</span>
								Price {{ item.price ? item.price.toLocaleString('th-TH') : $t("caption.uponRequest") }}
								{{ $t('baht') }}
							</div>
							<div class="card-cost" v-if="item.salaryType">
								{{ $t(item.salaryType) }}
							</div>
							<div class="user pl-2 pl-md-0">
								<div>
									<router-link
										id="sellerDetail"
										class="sellar-div"
										:to="$i18nRoute({ name: 'seller-detail' }, item.user.id)"
									>
										<AccountOutlineIcon />
										<span>{{ item.user && item.user.display_name }}</span>
									</router-link>
								</div>
								<div>
									{{$t('listingDetail.approve')}}
									<span class="approved"
										>({{ item.user && item.user.total_listing_approved }})</span
									>
								</div>
								<div>
									{{$t('listingDetail.disapproved')}}
									<span class="rejected"
										>({{ item.user && item.user.total_listing_rejected }})</span
									>
								</div>
								<div>
									{{ $t('all') }}
									<span class="total"
										>({{ item.user && item.user.total_listing }})</span
									>
								</div>
							</div>
							<div class="button-div">
								<b-button
									class="btn-grid"
									id="gotoListingDetails"
									@click="gotoListingDetails(item.id)"
								>
									<EyeIcon />
									<span class="d-none d-md-inline">{{$t('approveListing.see')}}</span>
								</b-button>
								<b-button
									class="btn-grid ml-2 ml-md-0"
									@click="approveListing(item.id)"
									id="approveListing"
								>
									<CheckIcon />
									<span class="d-none d-md-inline">{{$t('listingDetail.approve')}}</span>
									<!-- approve -->
								</b-button>
								<b-button
									v-if="item.status != 2"
									class="rejected ml-2 ml-md-0"
									@click="showModal(item.id)"
									id="onReject"
								>
									<EyeOffOutlineIcon />
									<span class="d-none d-md-inline">{{$t('listingDetail.disapproved')}}</span>
								</b-button>
								<b-button
									id="onDelete"
									class="delete ml-2 ml-md-0"
									@click="deletedItem(item.title, item.id)"
								>
									<TrashIcon />
									<span class="d-none d-md-inline">{{$t('approveListing.delete')}}</span>
								</b-button>
							</div>
						</b-col>
					</b-row>
					<infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
						<span slot="no-results"
							><b-alert show variant="light" v-if="!listingWaitingData.length"
								>{{$t('approveListing.no information')}}</b-alert
							></span
						>
						<span slot="no-more"></span>
					</infinite-loading>
				</b-container>
			</b-col>
		</b-row>
		<!-- MODAL -->
		<b-modal
			id="modal-not-approved"
			modal-class="modal-not-approved"
			centered
			hide-footer
			hide-header
		>
			<b-container fluid>
				<b-row class="mb-1 text-center">
					<div @click="hideModal" class="close-modal">
						<CloseIcon />
					</div>
					<div class="title">
						{{ $t('approveListing.modal.reasonsDisapproval') }}
					</div>
					<br />
					<div class="wrapper" style="width:100%;">
						<b-dropdown class="input-choose" no-flip>
							<template v-slot:button-content>
								<span>
									{{$t('listingDetail.choose reason')}}
									<ChevronDownIcon />
								</span>
							</template>
							<b-dropdown-item
								v-for="item in rejectOption"
								:key="item.value"
								@click="onChangeRejectMessage(item.value)"
								>{{ item.value }}</b-dropdown-item
							>
						</b-dropdown>
					</div>
					<b-form-textarea
						id="reasons-input"
						:placeholder="$t('advice')"
						rows="4"
						no-resize
						v-model="rejectMessage"
					></b-form-textarea>
					<div class="wrap-btn-send" @click="onReject">
						<b-button id="onRejectMessage" class="btn-send success-button">{{
							$t('approveListing.modal.send')
						}}</b-button>
					</div>
				</b-row>
			</b-container>
		</b-modal>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

// Icons
import EyeOffOutlineIcon from 'vue-material-design-icons/EyeOffOutline.vue';
import IconCogOutline from '@/components/icons/IconCogOutline/index';
import EyeIcon from '@/components/icons/IconEye/index';
import TrashIcon from '@/components/icons/IconTrash';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import ChevronDoubleUpIcon from 'vue-material-design-icons/ChevronDoubleUp.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import StarIcon from 'vue-material-design-icons/Star.vue';
import MonitorIcon from 'vue-material-design-icons/Monitor.vue';
// import PencilOutlinedIcon from "vue-material-design-icons/PencilOutline.vue";
import EditIcon from '@/components/icons/IconEdit/index';
import AccountOutlineIcon from 'vue-material-design-icons/AccountOutline.vue';
import MapMarkerIcon from 'vue-material-design-icons/MapMarker.vue';
import ListGridIcon from '@/components/icons/IconListGrid/index';
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';

import $ from 'jquery';
import { debounce } from 'lodash';
import moment from 'moment';
import Loading from '@/components/ui/loading';
import InfiniteLoading from 'vue-infinite-loading';
import { Trans } from '@/plugins/Translation';

export default {
	components: {
		IconCogOutline,
		EyeOffOutlineIcon,
		EyeIcon,
		CheckIcon,
		TrashIcon,
		CheckIcon,
		ChevronDoubleUpIcon,
		StarIcon,
		MonitorIcon,
		//PencilOutlinedIcon,
		EditIcon,
		AccountOutlineIcon,
		MapMarkerIcon,
		ListGridIcon,
		FormatListBulletedIcon,
		ChevronDownIcon,
		CloseIcon,
		Loading,
		InfiniteLoading
	},
	data() {
		return {
			pop2: false,
			typeViewAlllistings: 'grid',
			fields: [
				{ key: 'avatar', tdClass: 'tb-listing align-middle' },
				{ key: 'listing', label: this.$t('announce'), tdClass: 'align-middle' },
				{ key: 'status', label: this.$t('status'), tdClass: 'align-middle' },
				{ key: 'view', label: this.$t('audience'), tdClass: 'align-middle' },
				{ key: 'index', tdClass: 'align-middle' }
			],
			rejectOption: [
				{
					value: this.$t('Thank you for your posting because your announcement does not correspond to the subcategory you selected Please amend your announcement')
				},
				{
					value: this.$t('Thank you for posting Please check your announcement We only allow announcements based in Thailand')
				},
				{
					value: this.$t('Thank you for posting Please check your announcement We detected a duplicate announcement')
				},
				{
					value: this.$t('Thank you for posting Please check your announcement must be in Thai or English Please edit and resubmit Thank you')
				},
				{
					value: this.$t('Thank you for posting Please check your announcement Avoid political opinions')
				},
				{
					value: this.$t('Thank you for posting Please check your announcement Not in accordance with the terms of our posting policy')
				},
				{
					value: this.$t('Thank you for posting Please check your announcement We only allow announcements with images Please upload at least one picture of your announcement')
				}
			],
			rejectMessage: '',
			optionOrderBy: [
				{
					value: 'Promote',
					label: this.$t('concerned')
				},
				{
					value: 'Latest',
					label: this.$t('latest')
				},
				{
					value: 'PriceHigh',
					label: this.$t('high price')
				},
				{
					value: 'PriceLow',
					label: this.$t('low price')
				}
			],
			currentRejectID: undefined,
			itemCount: 0,
			totalWaitingForApprove: 0,
			listings: [],
			paramsGetWaitingForApprove: {
				take: 10,
				page: 1,
				fillter: 'All',
				sort_by: 'Promote',
				search: undefined
			},
			loading: false
		};
	},
	created() {
		document.getElementsByTagName('body')[0].addEventListener('click', e => {
			if (document.getElementsByClassName('popover').length) {
				this.$root.$emit('bv::hide::popover');
			}
		});
		this.getListings();
		this.onChangeFillter(this.paramsGetWaitingForApprove.fillter);
		this.getListingAttr();
	},
	computed: {
		...mapGetters('UserController', ['isMobile']),
		...mapGetters('ListingAdminController', [
			'listingsWaitingForApprove',
			'renewStatus',
			'rejectStatus',
			'deleteStatus',
			'listingWaitingData'
		]),
		...mapState('ListingDetailController', ['showRejectAcceptButton'])
	},
	watch: {
		deleteStatus: function(val) {
			if (val && val.success) {
				this.getListings();
				this.SET_ADMIN_DELETE_LISTING_STATUS({
					data: {}
				});
			}
		},
		renewStatus: function(val) {
			if (val && val.success) {
				this.getListings();
				this.SET_ADMIN_RENEW_LISTING_STATUS({
					data: {}
				});
			}
		},
		rejectStatus: function(val) {
			if (val && val.success) {
				this.getListings();
				this.hideModal();
				this.SET_ADMIN_REJECT_LISTING_STATUS({
					data: {}
				});
			}
		},
		listingsWaitingForApprove: function(val) {
			this.totalWaitingForApprove = val.totalWaitingForApprove;
			this.getListingAttr();
			// this.listings = val.listings;
		}
		// listingWaitingData: function (val) {

		//   this.listings = val;
		// },
		// paramsGetWaitingForApprove: function(val) {
		//   this.getListings();
		// }
	},
	methods: {
		...mapActions('ListingDetailController', ['SHOW_REJECT_ACCEPT_BUTTON']),
		...mapMutations('ListingDetailController', [
			'SET_SHOW_REJECT_ACCEPT_BUTTON'
		]),
		...mapMutations('ListingAdminController', [
			'SET_ADMIN_RENEW_LISTING_STATUS',
			'SET_ADMIN_REJECT_LISTING_STATUS',
			'SET_ADMIN_DELETE_LISTING_STATUS'
		]),
		...mapActions('ListingAdminController', [
			'GET_LISTINGS_WAITING_FOR_APPROVE',
			'ADMIN_RENEW_LISTING',
			'ADMIN_REJECT_LISTING',
			'ADMIN_DELETE_LISTING',
			'ADMIN_APPROVE_LISTING',
			'ADMIN_APPROVE_COUNT_LISTING'
		]),
		getListingAttr() {
			this.listingWaitingData.forEach(element => {
				element.listing_attributes_details.forEach(subElement => {
					if (subElement.attr_id == 15) {
						element.minSalary = subElement.value ? subElement.value : 0;
					}
					if (subElement.attr_id == 18 && subElement.pre_values_id != 56) {
						element.salaryType = subElement.listing_pre_value.value
							? subElement.listing_pre_value.value
							: null;
					}
				});
			});
		},
		onRenew(id) {
			this.ADMIN_RENEW_LISTING({
				id
			});
		},
		onReject() {
			if (this.currentRejectID && this.rejectMessage != '') {
				this.ADMIN_REJECT_LISTING({
					id: this.currentRejectID,
					comment: this.rejectMessage
				});
			}
		},
		onChangeRejectMessage(val) {
			this.rejectMessage = val;
		},
		getTotalAmount(user_payments) {
			return user_payments
				.reduce(function(result, item) {
					return result + item.total_amount;
				}, 0)
				.toLocaleString('th-TH');
		},
		tbodyTrClass(item, type) {
			if (this.checkExistPackage('Highlight', item.user_payments)) {
				return 'hidden_header_active';
			}
			return '';
		},
		onChangeSearch: debounce(function(data) {
			if (this.paramsGetWaitingForApprove.search !== data) {
				this.paramsGetWaitingForApprove = {
					...this.paramsGetWaitingForApprove,
					search: data
				};
			}
			this.getListings();
		}, 500),
		checkExistPackage(type, user_payments) {
			switch (type) {
				case 'Feature':
					let existFeature = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 1) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existFeature;
					break;
				case 'Bumpup':
					let existBumpup = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (
								temp.packages_detail&& (temp.packages_detail.package_id === 1 ||
								temp.packages_detail.package_id === 2)
							) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existBumpup;
					break;
				case 'QuickSale':
					let existQuickSale = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 3) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existQuickSale;
					break;
				case 'Negotiable':
					let existNegotiable = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail && temp.packages_detail.package_id === 4) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existNegotiable;
					break;
				case 'Highlight':
					let existHighlight = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&
								(temp.packages_detail.package_id === 1 ||
								temp.packages_detail.package_id === 5)
							) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existHighlight;
					break;
				case 'Website':
					let existWebsite = user_payments.find(item => {
						const existPackage = item.user_payments_details.find(temp => {
							if (temp.packages_detail&&temp.packages_detail.package_id === 6) {
								return true;
							}
							return false;
						});
						return !!existPackage;
					});
					return !!existWebsite;
					break;
			}
			return false;
		},
		onChangeOrderBy(data) {
			if (this.paramsGetWaitingForApprove.sort_by !== data) {
				this.paramsGetWaitingForApprove = {
					...this.paramsGetWaitingForApprove,
					sort_by: data
				};
			}
			this.getListings();
		},
		onChangeFillter(data) {
			this.ADMIN_APPROVE_COUNT_LISTING(data).then(result => {
				this.itemCount = result.data.itemCount;
			});
			// if (this.paramsGetWaitingForApprove.fillter !== data) {
			//   this.paramsGetWaitingForApprove = {
			//     ...this.paramsGetWaitingForApprove,
			//     fillter: data
			//   };
			// }
			// this.listings = [],
			// this.$store.commit("ListingAdminController/RESET_LISTINGS_WAITING_DATA")
			// this.paramsGetWaitingForApprove.page = 1;
			// this.$nextTick(() => {
			//   this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
			// });
			//this.getListings();
		},
		getListings() {
			this.paramsGetWaitingForApprove.page = 1;
			this.GET_LISTINGS_WAITING_FOR_APPROVE(this.paramsGetWaitingForApprove);
		},
		formatDate(date) {
			return moment(date)
				.locale(Trans.currentLanguage)
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local(Trans.currentLanguage)
				.format('HH:mm');
		},
		changeTypeViewAlllistings(type) {
			this.typeViewAlllistings = type;
		},
		goToPromoteOption() {
			this.$router.push(this.$i18nRoute({ name: 'packages-screen' }));
		},
		deletedItem(name, id) {
			this.$swal({
				title: this.$t('you want to delete'),
				text: name,
				customClass: {
					container: 'swal-del-item'
				},
				showCancelButton: true,
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				cancelButtonColor: '#DC3849',
				confirmButtonText: this.$t('cancel'),
				cancelButtonText: this.$t('delete')
			}).then(result => {
				if (result.dismiss == 'cancel') {
					// this.loading=true;
					this.ADMIN_DELETE_LISTING({
						id
					}).then(()=>{
						// this.loading=false;
					}).catch(()=>{
						// this.loading=false;
					});
				}
			});
		},
		showSuggestions(suggest) {
			this.$swal({
				title: this.$t('Advice from administrators'),
				text: suggest,
				customClass: {
					container: 'swal-suggest'
				},
				confirmButtonColor: 'var(--projectPrimaryColor) !important',
				confirmButtonText: this.$t('acknowledge')
			});
		},
		showModal(id) {
			this.currentRejectID = id;
			this.$bvModal.show('modal-not-approved');
		},
		hideModal() {
			this.currentRejectID = undefined;
			this.$bvModal.hide('modal-not-approved');
		},
		gotoListingDetails(id) {
			this.SHOW_REJECT_ACCEPT_BUTTON(true);
			this.$router.push(
				this.$i18nRoute(
					{
						name: 'admin-approve-listing'
					},
					id
				)
			);
		},
		infiniteHandler($state) {
			this.GET_LISTINGS_WAITING_FOR_APPROVE(
				this.paramsGetWaitingForApprove
			).then(async response => {
				if (response.length > 0) {
					if (response.length < this.paramsGetWaitingForApprove.take) {
						return await $state.complete();
					}
					this.paramsGetWaitingForApprove.page += 1;
					await $state.loaded();
				} else {
					await $state.complete();
				}
			});
		},
		approveListing(listing_id) {
			this.loading=true;
			this.ADMIN_APPROVE_LISTING({
				id: listing_id
			}).then(result => {
				if (result.success) {
					this.loading=false;
					this.getListings();
				}
			}).catch(()=>{
				this.loading=false;
			});;
		},
		funcSubString(string, number) {
			let subStr = '';
			if (string.length > number && string.indexOf(' ') !== -1) {
				subStr =
					string.substring(0, string.substring(0, number).lastIndexOf(' ')) +
					' ...';
			} else {
				subStr = string;
			}
			return subStr.toString();
		}
	}
};
</script>

<style lang="scss">
@import 'adminApproveListing.scss';
</style>
